module.exports = __webpack_public_path__ + "static/img/btn.b89e098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market103/btn.png
// module id = Lfj8
// module chunks = 1